import { render, staticRenderFns } from "./PartnerFooter.vue?vue&type=template&id=6572fe38&scoped=true&"
import script from "./PartnerFooter.vue?vue&type=script&lang=js&"
export * from "./PartnerFooter.vue?vue&type=script&lang=js&"
import style0 from "./PartnerFooter.vue?vue&type=style&index=0&id=6572fe38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6572fe38",
  null
  
)

export default component.exports